import { rankingSourceUrl, rankingDetailUrl, rankingCoverUrl } from '../../../utils/hongguoRankingDisplay.js';
export {
  HONGGUO_BOARDS, rankingPageKey, rankingSourceUrl, rankingMetric, rankingDetailUrl,
  rankingCoverUrl, rankingTime, searchRankingPage,
} from '../../../utils/hongguoRankingDisplay.js';

const STATUSES = new Set(['EMPTY', 'READY', 'REFRESHING', 'FAILED', 'COOLDOWN']);
const cleanText = value => typeof value === 'string' && value.trim() ? value.trim() : null;

export const rankingCooldownSeconds = (nextRefreshAt, now = Date.now()) => {
  const timestamp = new Date(nextRefreshAt || '').getTime();
  return Number.isFinite(timestamp) ? Math.max(0, Math.ceil((timestamp - now) / 1000)) : 0;
};

// Reject an unexpected page instead of ever showing one board's rows under another title.
export const normalizeRankingSnapshot = (data, board, page) => {
  if (!data || data.board !== board || data.page !== page || !STATUSES.has(data.status) || !Array.isArray(data.items)) {
    throw new Error('榜单响应与当前分类或页码不匹配，已保留原有数据。');
  }
  let sourceUrl = rankingSourceUrl(board);
  try {
    const url = new URL(data.sourceUrl);
    if (url.origin === 'https://hongguoduanju.com' && url.pathname === `/rank/${board}` && !url.username && !url.password) sourceUrl = url.href;
  } catch { /* An absent or unsafe URL uses the known public board link. */ }
  return {
    ...data,
    sourceUrl,
    sourceUpdatedText: cleanText(data.sourceUpdatedText),
    warning: cleanText(data.warning),
    stale: data.stale === true,
    totalPages: Number.isInteger(data.totalPages) ? Math.max(1, Math.min(5, data.totalPages)) : 5,
    items: data.items.slice(0, 20).filter(row => row && typeof row === 'object').map(row => ({
      rank: Number.isInteger(row.rank) && row.rank > 0 ? row.rank : null,
      // Never coerce a numeric ID that may already have lost precision.
      seriesId: typeof row.seriesId === 'string' ? row.seriesId : '',
      title: cleanText(row.title) || '未提供剧名',
      heatText: cleanText(row.heatText), scoreText: cleanText(row.scoreText),
      favoriteText: cleanText(row.favoriteText), likeText: cleanText(row.likeText),
      tags: Array.isArray(row.tags) ? row.tags.filter(tag => typeof tag === 'string' && tag.trim()).slice(0, 6) : [],
      detailUrl: rankingDetailUrl(row.seriesId),
      coverUrl: rankingCoverUrl(row.coverUrl),
    })),
  };
};

export const mergeRankingSnapshot = (previous, incoming) => {
  // A failed refresh/read may return status only. Its empty list must not erase good rows.
  if (previous?.items?.length && !incoming.items.length && ['FAILED', 'REFRESHING', 'COOLDOWN'].includes(incoming.status)) {
    return {
      ...incoming, items: previous.items, fetchedAt: previous.fetchedAt,
      sourceUpdatedText: previous.sourceUpdatedText, sourceUrl: previous.sourceUrl, stale: true,
    };
  }
  return incoming;
};
